export const localStorageKeys = {
  PAYMENT_INFO: 'paymenInfo',
  SESSION: 'session',
  GIFT_AID_NUDGE_SNOOZE: 'giftAidNudgeSnooze',
  PROGRAM_ANNOUNCEMENT_DISMISSALS: 'programAnnouncementDismissals'
};
